module.exports = __webpack_public_path__ + "static/media/carousel-img3.11d89d51.png";